// Real product routes the tour hands off to. Kept separate from the step defs so
// a route change is a single edit, and so tourSteps has no import cycle.
export const ROUTES_TOUR = {
  TOUR: '/welcome-tour',
  DASHBOARD: '/dashboard',
  BILLING: '/account-settings/billing',
  ACCOUNTS: '/accounts',
  COPIER: '/trade-copier/copier-settings',
  COPIER_LOGS: '/trade-copier/copier-logs',
  INTEGRATION: '/integration'
} as const;

/** On the full-screen tour route (no MainLayout, so no checkout drawer). */
export const onTourRoute = (): boolean => window.location.pathname.startsWith(ROUTES_TOUR.TOUR);
